import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentService } from 'src/app/_services/document.service';
import { ToastrService } from 'ngx-toastr';
import { File } from 'src/app/_model/File';
import { DialogCloseData } from "../../_model/models";
import { DIALOG_OPERATIONS } from "../../_utils/constants";
interface FileNode {
  id: number;
  fileName: string;
  fileDescription: string;
  storageDocuments?: File[];
  filePath: string;
  type: 'file' | 'folder';
  url: string;
  children?: FileNode[];
  parent: FileNode | null;
}
@Component({
  selector: 'app-generaldocument-delete',
  templateUrl: './generaldocument-delete.component.html',
  styleUrls: ['./generaldocument-delete.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class GeneraldocumentDeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<GeneraldocumentDeleteComponent>,
    private documentService: DocumentService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: FileNode,
    private toastr: ToastrService) { }

  ngOnInit() {
  }

  getConfirmationMessage(): string {
        if (this.data.type === 'folder') {
            return `"${this.data.fileName}" adlı klasörü silmek istediğinize emin misiniz? 
                   Bu klasör altındaki klasör ve evraklara daha sonra erişim sağlayamayacaksınız!`;
        }
        return `"${this.data.fileName}${this.data.fileDescription ? ' - ' + this.data.fileDescription : ''}" 
                adlı evrakı silmek istediğinize emin misiniz?`;
    }

  deleteFile(id: any) {
    this.documentService.deleteDocument(this.data.id).subscribe(result => {
      this.toastr.success('Silme işlemi başarılı', '');
      this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.DELETE, this.data.id));
    }, error => {
      this.toastr.error(error.error.msg, 'Hata');
      this.dialogRef.close();
    });
  }
}
